import React from 'react'

const BoltIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 22 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.9999 0.19873V9.00014H21.1101L8.99989 23.8015V15.0001H0.889648L12.9999 0.19873ZM5.11013 13.0001H10.9999V18.1987L16.8896 11.0001H10.9999V5.80155L5.11013 13.0001Z" />
    </svg>
  )
}

export default BoltIcon
